import { changeableTaskStatuses } from '../../constants/common';
import { modes } from '../../constants/modes';
import {
  SET_CALENDAR_SHEET,
  SET_WORKERS,
  SET_CALENDAR_DATA,
  SET_VIEW,
  SET_TASKS_MODAL_VISIBLE,
  SET_TASKS_MODAL_DATA,
  SET_MODE,
  SET_STATE,
  SET_LOCAL_TASK,
  SET_INFO_MODAL_VISIBLE,
  SET_CHANGEABLE_TASK_STATUS,
  SET_INNER_ACTIVATION_OF_CHANGE,
  TOGGLE_OWNER,
} from '../actions/actionTypes';

export const initialState = {
  calendarSheet: undefined,
  workers: [],
  calendarData: [],
  view: undefined,
  tasksModalVisible: false,
  tasksModalData: null,
  mode: modes.calendar,
  state: undefined,
  localTask: null,
  infoModalVisible: false,
  changeableTaskStatus: changeableTaskStatuses.edit,
  innerActivationOfChange: false,
  showOwner: false,
};

const newCalendarReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CALENDAR_SHEET:
      return {
        ...state,
        calendarSheet: payload,
      };
    case SET_WORKERS:
      return {
        ...state,
        workers: payload,
      };
    case SET_CALENDAR_DATA:
      return {
        ...state,
        calendarData: payload,
      };
    case SET_VIEW:
      return {
        ...state,
        view: payload,
      };
    case SET_TASKS_MODAL_VISIBLE:
      return {
        ...state,
        tasksModalVisible: payload,
      };
    case SET_TASKS_MODAL_DATA:
      return {
        ...state,
        tasksModalData: payload,
      };
    case SET_MODE:
      return {
        ...state,
        mode: payload,
      };
    case SET_STATE:
      return {
        ...state,
        state: payload,
      };
    case SET_LOCAL_TASK:
      return {
        ...state,
        localTask: payload,
      };
    case SET_INFO_MODAL_VISIBLE:
      return {
        ...state,
        infoModalVisible: payload,
      };
    case SET_CHANGEABLE_TASK_STATUS:
      return {
        ...state,
        changeableTaskStatus: payload,
      };
    case SET_INNER_ACTIVATION_OF_CHANGE:
      return {
        ...state,
        innerActivationOfChange: payload,
      };
    case TOGGLE_OWNER:
      return {
        ...state,
        showOwner: !state.showOwner,
      };
    default:
      return state;
  }
};

export default newCalendarReducer;
